import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';

export const useWalletBalance = () => {
    const [walletBalance, setWalletBalance] = useState<number>(0);
    const [loading, setLoading] = useState(true);

    const refetch = useCallback(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            setLoading(false);
            return;
        }
        setLoading(true);
        axios
            .get(`${CONFIG.apiUrl}/user/wallet`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                setWalletBalance(res.data.walletBalance || 0);
            })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        refetch();
    }, [refetch]);

    return { walletBalance, loading, refetch };
};
